export default __webpack_public_path__ + "static/media/back.cadd8e14.svg";